export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_03.84db9cb8.jpg";